import AbstractInstaller from "../core/application/AbstractInstaller";

export default class AppSpecificInstaller extends AbstractInstaller {
    /**
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        // EXAMPLES:
        // commands.add(InitializeSituationsEvent.PERFORM, InitializeSituationsCommand);
        // injector.mapClass("situationLibrary", SituationLibrary, true);
        // SkinKeyRegistry.ACT_SCREEN_SKIN = this._mapMediator(ActScreenMediator, lib.MainAssets.ActScreenSkin);
        // this._addStartupTask(InitializeSituationsToPlayTask, "initializeSituationsToPlayTask", 10);
    }
}